import React, { PureComponent } from "react";
import { Route } from "react-router-dom";
import Button from "@material-ui/core/Button";
import VerticalSpace from "./components/VerticalSpace";
// import ButtonAppBar from "./components/ButtonAppBar";
import Grid from "@material-ui/core/Grid";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import { withRouter } from "react-router-dom";

class InvConfirmation extends PureComponent {
  constructor(props) {
    super(props);
    const inv = this.props.location.state
      ? this.props.location.state.invoice
      : null;
    this.state = {
      invoice: inv
    };
  }

  render() {
    const OkButton = props => (
      <Route
        render={({ history }) => (
          <div>
            <Button
              variant="outlined"
              style={{ width: "100%" }}
              onClick={() => {
                history.push({
                  pathname: "/"
                });
              }}
            >
              Ok
            </Button>
          </div>
        )}
      />
    );

    return (
      <div>
        {/* <ButtonAppBar /> */}
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <VerticalSpace />
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Appointment</h4>
                </center>
                <br />
              </div>
              <form className="form form--horizontal">
                <div className="form__form-group">
                  <p>
                    <b>Invoice payment created successfully.</b>
                  </p>
                </div>
                <div className="form__form-group">
                  <p>Amount Paid: {this.state.invoice.Amount}</p>
                </div>
                {/* <div className="form__form-group">
                  <p>Receipt: 201809019091</p>
                </div> */}
                <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={3} />
                    <Grid item xs={6}>
                      <OkButton />
                    </Grid>
                    <Grid item xs={3} />
                  </Grid>
                  <VerticalSpace />
                </div>
              </form>
              <SimpleBottomNavigation value={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(InvConfirmation);



// WEBPACK FOOTER //
// ./src/pages/main/InvConfirmation.js